/**
 * Clear the cart using Shopify AJAX API.
 *
 * @returns {Promise<void>}
 */
async function clearCart() {
  try {
    const response = await fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "xmlhttprequest", // Shopify expects this header for AJAX requests
      },
    });

    const data = await response.json();
    console.log("Cart cleared:", data, Shopify.clear());
  } catch (error) {
    throw new Error("Error clearing cart:", error);
  }
}

/**
 * Check if the local storage of the browser is available
 *
 * @return Availability of the local storage (boolean)
 */
function isLocalStorageAvailable() {
  try {
    localStorage.setItem("check", "availability");
    localStorage.removeItem("check");
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Create a cookie item
 * Make sure the user has given his consent to the usage of cookies
 *
 * @param item
 * @param value
 */
function createCookie(item, value) {
  if (item === "" || value === "") return;
  if (isLocalStorageAvailable()) {
    localStorage.setItem(item, value);
  }
}

/**
 * Get a cookie item (raw, cookie consent is not required)
 *
 * @param item
 */
function getRawCookie(item) {
  if (!isLocalStorageAvailable() || !localStorage.getItem(item)) return;
  return localStorage.getItem(item);
}

/**
 * Set a GET parameter
 *
 * @param {*} key
 * @param {*} value
 */
function insertGETParam(key, value) {
  key = encodeURIComponent(key);
  value = encodeURIComponent(value);

  // kvp looks like ['key1=value1', 'key2=value2', ...]
  var kvp = document.location.search.substr(1).split("&");
  let i = 0;

  for (; i < kvp.length; i++) {
    if (kvp[i].startsWith(key + "=")) {
      let pair = kvp[i].split("=");
      pair[1] = value;
      kvp[i] = pair.join("=");
      break;
    }
  }

  if (i >= kvp.length) {
    kvp[kvp.length] = [key, value].join("=");
  }

  // Can return this or...
  let params = kvp.join("&");

  // Reload page with new params
  // But not here right away
  return "?" + params;
}

/**
 * Get all URL parameters
 * 
 * @returns {object}
 */
function getURLParams() {
  // Parse the query string
  const queryString = window.location.search;

  // Remove the leading "?" and split the string into an array of key-value pairs
  const params = queryString.substring(1).split('&');

  const paramsObject = {};
  // Loop through the key-value pairs and populate the object
  params.forEach(param => {
    const [key, value] = param.split('=');
    paramsObject[key] = decodeURIComponent(value);
  });

  return paramsObject;
}
